import { cn } from '@/shadcn-ui/utils';
import { BackgroundColor } from '@/theme/types';

export interface RuleProps {
  direction: 'horizontal' | 'vertical';
  color?: BackgroundColor;
  className?: string;
}
export default function Rule({
  direction,
  color = 'bg-flexcar-neutral80',
  className,
}: RuleProps) {
  switch (direction) {
    case 'horizontal':
      return <div className={cn('h-[1px] w-full', color, className)} />;

    case 'vertical':
      return <div className={cn('h-full w-[1px]', color, className)} />;
  }
}
